// copied from index.html
export function resolveUrl(tplName) {
    const u = window.urls[tplName];
    if (u) {
        if (u.indexOf('.json') > -1) {
            return u;
        }
        return u + '?version=' + Date.now();
    }
    return 'notFound';
}

export function getSitePath() {
    if (import.meta.env.MODE !== 'production') {
        return '';
    }
    return '/ott/';
}

// TODO: Clean up contextPath usage
export function getContextPath() {
    return getBackendHost();
}

export function getBackendHost() {
    return import.meta.env.VITE_ENV_OTT_API_HOST;
}